module.exports = __webpack_public_path__ + "img/menu-switch.ea407399.svg";